import React , { useState } from 'react';
import { Link } from 'react-router-dom'

const Action = () => {

    const [data] = useState(
        {
            title: 'Hostel Rodex',
            desc: '¡Vení a conocernos, te esperamos!',
        }
    )

    return (
        <section className="tf-section action">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="action__body" data-aos="fade-up">
                            <div className="block-text">
                                <h3 className="mb-13">{data.title}</h3>
                                <p className="fs-21 mb-7">{data.desc}</p>
                            </div>
                            <a href="https://wa.link/cgn7fi" target="_blank" rel="noopener noreferrer" className="btn-action style-2">Reservar por Whatsap</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Action;